class SMStorage {
  static getSessionItem(key){
    const cache = JSON.parse(sessionStorage.getItem(key));
    const sec = (new Date()).getTime() / 1000;
    if (cache && cache.exp > sec && cache.data) {
      return cache.data;
    }
    return; 
  }
  
  static setSessionItem(key, value, expSec){
    expSec = expSec || 0;
    const now = new Date();
    const cache = {
      data: value,
      exp: now.getTime() / 1000 + expSec,
    };
    sessionStorage.setItem(key, JSON.stringify(cache));
  }
  
  static removeSessionItem(key){
    sessionStorage.removeItem(key);
  }
  
  static getPersistentItem(key){
    const cache = JSON.parse(localStorage.getItem(key));
    const sec = (new Date()).getTime() / 1000;
    if (cache && cache.exp > sec && cache.data) {
      return cache.data;
    }
    return; 
  }
  
  static setPersistentItem(key, value, expSec){
    expSec = expSec || 0;
    const now = new Date();
    const cache = {
      data: value,
      exp: now.getTime() / 1000 + expSec,
    };
    localStorage.setItem(key, JSON.stringify(cache));
  }
  
  static removePersistentItem(key){
    localStorage.removeItem(key);
  }
};
export default SMStorage;



// WEBPACK FOOTER //
// ./app/javascript/lib/SMStorage.js